const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const trackingUtils = require('../../../../webapp/static-content/_versionedByRelease_/js/modules/utils/tracking.utils');

const OPEN_CLASSES = 'opened open';
const BAGS_SELECTOR = '.bags_add_popup';
const SEATS_SELECTOR = '.seats_add_popup';
const CATEGORY = 'my_area_trips_details';

const createAncillariesOffline = (type, view) => {
    const {widgetPosition, options} = view;
    const bagsPopup = type === 'bags';
    const loadEvent = bagsPopup ? ':loadBags' : ':loadSeats';
    const selector = bagsPopup ? BAGS_SELECTOR : SEATS_SELECTOR;
    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
    const bookingId = bookingInfo.bookingBasicInfo.id;
    const trackEvent = function(action, labelPrefix) {
        const trackingAction = [action, type].join('_');
        const trackingLabelChunks = [labelPrefix, type];
        if (!Odigeo._.isUndefined(widgetPosition)) {
            trackingLabelChunks.push(`pos:${widgetPosition}`);
        }
        if (!options.trackBookingIdOnDialup) {
            trackingLabelChunks.push(`id:${bookingId}`);
        }
        const trackingLabel = trackingLabelChunks.join('_');
        trackingUtils.trackEventWithCategory(CATEGORY, trackingAction, trackingLabel);
    };
    trackEvent('widget', 'show');

    return {
        openPopup(action) {
            trackEvent(Odigeo._.isString(action) ? action : 'widget', 'open');
            Odigeo.trigger(view.name + loadEvent, bookingInfo);
        },
        closePopup() {
            view.$el.find(selector).removeClass(OPEN_CLASSES);
        },
        dialup() {
            const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
            const bookingId = bookingInfo.bookingBasicInfo.id;
            const action = 'popup_' + type;
            const label = 'call_' + type + '_' + bookingId;
            trackingUtils.trackEventWithCategory(CATEGORY, action, label);
        },
    };
};

module.exports = withRenderedMain(BaseView.extend({
    events: {
        'tap .open_add_bags': 'addBags',
        'tap .open_choose_seats': 'chooseSeats',
        'tap .close_add_bags': 'closeBagsPopup',
        'tap .close_add_seats': 'closeSeatsPopup',
        'tap .dialup_add_bags': 'dialupBags',
        'tap .dialup_add_seats': 'dialupSeats',
    },

    initialize(options) {
        const isNewBagsPostbooking = Odigeo.AB.isEnhancedPostbookingBagsMobile
            || Odigeo.AB.isEnhancedPostbookingBagsDesktop;
        const isNewSeatsPostbooking = Odigeo.AB.isEnhancedPostbookingSeatsMobile
            || Odigeo.AB.isEnhancedPostbookingSeatsDesktop;

        this.model = options.model;
        this.widgetPosition = options.widgetPosition;

        if (!isNewBagsPostbooking) {
            this.bagsOffline = createAncillariesOffline('bags', this);
        }

        if (!isNewSeatsPostbooking) {
            this.seatsOffline = createAncillariesOffline('seats', this);
        }
    },

    closeBagsPopup() {
        this.bagsOffline.closePopup();
    },
    closeSeatsPopup() {
        this.seatsOffline.closePopup();
    },
    addBags(action) {
        this.bagsOffline.openPopup(action);
    },
    chooseSeats(action) {
        this.seatsOffline.openPopup(action);
    },
    dialupBags() {
        this.bagsOffline.dialup();
    },
    dialupSeats() {
        this.seatsOffline.dialup();
    },
}));
